// Sustituto de 'firebase/app'
const apps = [];
export function initializeApp(options = {}, name = '[DEFAULT]') {
  const app = { name, options, automaticDataCollectionEnabled: false };
  apps.push(app);
  return app;
}
export const getApp = () => apps[0] || initializeApp();
export const getApps = () => apps;
export const deleteApp = async () => {};
export const registerVersion = () => {};
export { FirebaseError } from './wire.js';
